import React from 'react';
import { Box, DialogTitle, DialogContent, Typography, Card, Stack, IconButton, Chip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';
import moment from 'moment';
import _ from 'lodash';
import useAuth from 'hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export default function DialogData(props) {
  const { setEmployeeDetailDialog, employeeData, employeeLoginId } = props;
  const theme = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <Card sx={{ p: 2 }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
        <DialogTitle variant="h3">
          Employee Details
          <Chip
            label={employeeLoginId}
            size="small"
            sx={{ backgroundColor: 'green', color: 'white' }}
            variant="contained"
            style={{ marginLeft: 12 }}
          />
          {user?.role === 'EMPLOYEE' && (
            <IconButton
              onClick={() => {
                navigate(`/spEmployee/edit?employeeId=${employeeData?.employeeId}`);
                setEmployeeDetailDialog(false);
              }}
            >
              <EditIcon fontSize="small" sx={{ color: 'red' }} />
            </IconButton>
          )}
        </DialogTitle>
        <IconButton onClick={() => setEmployeeDetailDialog(false)}>
          <CloseIcon />
        </IconButton>
      </div>

      <div style={{ height: '100%', flexDirection: 'column', overflow: 'scroll', paddingBottom: '36px' }}>
        <DialogContent>
          <Card sx={{ p: 1, mt: 2 }}>
            <Typography>Basic Info</Typography>
            <Stack spacing={2} sx={{ paddingLeft: 1, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>Name</Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.name}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Designation
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.designation}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Employee Id
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.employeeId}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Employee Id
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.employeeId}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>Email</Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.email}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Primary Phone No.
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>
                  {employeeData?.phoneNumber?.primary ? `+91${employeeData?.phoneNumber?.primary}` : ''}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Secondary Phone No.
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>
                  {employeeData?.phoneNumber?.secondary ? `+91${employeeData?.phoneNumber?.secondary}` : ''}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Address
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.address}</Typography>
              </Box>
              {employeeData?.dateOfBirth !== null && (
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                    Date of birth
                  </Typography>
                  <Typography sx={{ fontSize: '14px' }}>
                    {moment(employeeData?.dateOfBirth).format('DD MMM YY')}
                  </Typography>
                </Box>
              )}
            </Stack>
          </Card>
          <Card sx={{ p: 1, mt: 2 }}>
            <Typography>Emergency Details</Typography>
            <Stack spacing={2} sx={{ paddingLeft: 1, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Primary Name
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.emergencyDetails?.primary?.name}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Primary Phone No.
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>
                  {employeeData?.emergencyDetails?.primary?.phoneNumber
                    ? `+91${employeeData?.emergencyDetails?.primary?.phoneNumber}`
                    : ''}{' '}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Secondary Name
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>{employeeData?.emergencyDetails?.secondary?.name}</Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Secondary Phone No.
                </Typography>
                <Typography sx={{ fontSize: '14px' }}>
                  {employeeData?.emergencyDetails?.secondary?.phoneNumber
                    ? `+91${employeeData?.emergencyDetails?.secondary?.phoneNumber}`
                    : ''}
                </Typography>
              </Box>
            </Stack>
          </Card>

          <Card sx={{ p: 1, mt: 2, mb: 4 }}>
            <Typography>Profile</Typography>
            <Stack spacing={2} sx={{ paddingLeft: 1, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Typography sx={{ fontSize: '14px', width: '350px', fontWeight: 500, opacity: 0.4 }}>
                  Employee Image
                </Typography>
                <Box
                  component="img"
                  src={employeeData?.profileImageUrl}
                  sx={{ border: '1 px solid #999999', height: '80px', width: '80px', borderRadius: '2px' }}
                />
              </Box>
            </Stack>
          </Card>
        </DialogContent>
      </div>
    </Card>
  );
}
